import { IThunderboltEntry } from '@wix/editor-elements-types';

import {
  registerComponentTypeUiTypes,
  UiTypesRegistrationMap,
} from '../../../registration/registration';

const UiTypes: UiTypesRegistrationMap = {
  '': () => [import('./viewer/Section' /* webpackChunkName: "Section" */)],
};

const entry: IThunderboltEntry = {
  loadComponent: registerComponentTypeUiTypes('Section', UiTypes),
};

export default entry;
